<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 2000">
		<div style="width: 500px">
			<!-- Header -->
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">
					{{ $t("shift-document") }}
					<strong v-if="document">{{ document.title }}</strong>
				</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close')" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>

			<!-- Body -->
			<div class="dialog-body">
				<div class="container">
					<span>{{ $t("projects-search") }}</span>
					<div>
						<el-select
							v-model="destination"
							:placeholder="$t('projects')"
							style="width: 100%"
							filterable
							remote
							:remote-method="getProjects"
							:loading="loading"
						>
							<el-option-group v-for="project in projects" :key="project.id" :label="project.name">
								<el-option :label="project.name" :value="project.id"></el-option>
								<el-option
									v-for="procedure in project.procedures"
									:key="procedure.id"
									:label="procedure.name"
									:value="`${project.id}-${procedure.id}`"
								>
									<md-icon>folder_open</md-icon>
									<span>{{ procedure.name }}</span>
								</el-option>
							</el-option-group>
						</el-select>
					</div>
				</div>
			</div>

			<!-- Footer -->
			<div class="dialog-footer">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close')">
						{{ $t("cancel") }}
					</md-button>
					<md-button class="add" @click="shift" :disabled="!destination">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("shift") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"
import { mapGetters } from "vuex"

export default {
	name: "shift-document",
	props: {
		show: {
			type: Boolean,
			required: true
		},
		document: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		projects: [],
		loading: false,
		destination: null
	}),
	computed: mapGetters("user", ["isSuperAdmin"]),
	watch: {
		show(newValue) {
			if (newValue) this.getProjects("")
			else this.clearData()
		}
	},
	methods: {
		clearData() {
			this.project = []
			this.loading = false
			this.destination = null
		},
		getProjects(searchTerm) {
			this.loading = true

			const filters = {
				pagination: {
					size: 15
				},
				search: (searchTerm || "").toLowerCase(),
				organization_id: this.$route.params.school_id,
				include_procedures: true
			}

			axios
				.post(`${process.env.VUE_APP_API_URL}/api/projects/get`, filters, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(({ data: { items = [] } }) => {
					this.projects = items
						.filter(({ project_id }) => !project_id)
						.map(project => ({
							...project,
							procedures: items.filter(
								({ project_id }) =>
									project_id === project.id && project_id !== this.$route.params.folder_id
							)
						}))

					if (this.projects.length === 0 && items.length > 0)
						this.projects = [
							{
								...items[0].project,
								procedures: items
							}
						]
				})
				.finally(() => (this.loading = false))
		},
		shift() {
			const [destinationProjectId, destinationProcedureId] = this.destination.split("-")

			axios
				.put(
					`${process.env.VUE_APP_API_URL}/api/documents/shift/${this.document.id}`,
					{
						project_id: destinationProcedureId || destinationProjectId
					},
					{
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					}
				)
				.then(() => {
					this.$emit("close")

					const subRouteName = this.isSuperAdmin ? "school-projects.school_id" : "my-projects"
					const route = {
						name: `projects.${subRouteName}.project_id${destinationProcedureId ? ".folder_id" : ""}`,
						params: {
							...(this.isSuperAdmin && { school_id: this.$route.params.school_id }),
							project_id: destinationProjectId,
							...(destinationProcedureId && { folder_id: destinationProcedureId })
						}
					}

					this.$router.push(route)
				})
				.catch(error => console.error(error))
		}
	}
}
</script>
